export const REMOVE_PAGE = 'REPORTING_REMOVE_PAGE';

export const removePage = pageIndex => ({
  type: REMOVE_PAGE,
  pageIndex,
});
